module.exports = __webpack_public_path__ + "img/ic_pathbar_followroads_off.739bd9c5.svg";